import { useEffect, useState } from "react";
import { ketQuaLienHeApi } from "../../api/ketQuaLienHeApi";
import { NotifyHelper } from "../../helpers/toast";

export interface IKetQuaLienHeItem {
    id: number;
    ten_ket_qua: string;
    is_active: boolean;
    co_ngay_hen: boolean;
}

// Danh sách kết quả liên hệ đang hoạt động của cơ sở, giống danh mục dùng ở Kho Lead
export const useKetQuaLienHe = (dm_coso_id?: number): IKetQuaLienHeItem[] => {
    const [ketQuaLienHes, setKetQuaLienHes] = useState<IKetQuaLienHeItem[]>([]);

    useEffect(() => {
        if (!dm_coso_id) {
            setKetQuaLienHes([]);
            return;
        }
        ketQuaLienHeApi.select_by_coso(dm_coso_id).then((res: any) => {
            if (!res.is_success) {
                NotifyHelper.Error(res.message || "Không tải được danh sách kết quả liên hệ");
                return;
            }
            setKetQuaLienHes(Array.isArray(res.data) ? res.data.filter((x: IKetQuaLienHeItem) => x.is_active) : []);
        });
    }, [dm_coso_id]);

    return ketQuaLienHes;
};
